export default '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor"><path d="m0 8.5h20v3h-20z"/><path d="m8.5 20v-19.99999987l3-.00000013v20z"/></g></svg>';
export const title = "interface-add-small";
export const tags = "nordicon interface add small plus adding more sign";
